// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"unfold-less"},"children":[{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M16 19L12 15L8 19M16 5L12 9L8 5","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const UnfoldLessIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'unfold-less',
    ref,
    icon: element,
  },
));

UnfoldLessIcon.displayName = 'UnfoldLessIcon';

export default UnfoldLessIcon;
